import React from 'react';
import { Line } from 'react-chartjs-2';
import {
  Chart as ChartJS,
  LinearScale,
  CategoryScale,
  PointElement,
  LineElement,
  Filler,
  Tooltip,
  Legend,
} from 'chart.js';

// Register the components
ChartJS.register(LinearScale, CategoryScale, PointElement, LineElement, Filler, Tooltip, Legend);

const LeaderboardChart = ({ data = [] }) => {
  // Prepare data for the chart
  const chartData = {
    labels: data.map(item => item.name || 'Unknown'), // Names of the hunters
    datasets: [
      {
        label: 'Geotags Hunted',
        data: data.map(item => item.count || 0), // Count of geotags hunted
        fill: false,
        backgroundColor: 'rgba(75,192,192,0.4)',
        borderColor: 'rgba(75,192,192,1)',
      },
    ],
  };

  const options = {
    scales: {
      y: {
        beginAtZero: true,
      },
    },
  };

  return (
    <div>
      <h2>Top Hunters Leaderboard</h2>
      <Line data={chartData} options={options} />
    </div>
  );
};

export default LeaderboardChart;